enum SolveType {
  TakeLess,
  PayMore,
  EquityRelease
}

export default SolveType;
